import * as globals from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;

  &&&& {
    border-radius: 10px;
  }

  background-color: ${globals.white};
  color: ${globals.textPrimary};
  @media only screen and (max-width: ${globals.tabletBreakpoint}) {
    flex-flow: row wrap;
  }
`;

const containerStyle = `
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 40px;
  flex-shrink: 0;
   @media only screen and (max-width: ${globals.tabletBreakpoint}) {
    width: 100%;
  }
`;

export const MainContainer = styled.div`
  ${containerStyle};

  justify-content: space-between;
  background-color: ${globals.MOON_50};
  color: ${globals.textPrimary};
  width: 350px;
`;

export const SideContainer = styled.div`
  ${containerStyle};

  width: 400px;
  max-width: 100%;
  background-color: ${globals.white};
  color: ${globals.textPrimary};
`;

export const PlanOverviewSection = styled.div``;

export const HeaderSection = styled.div`
  margin-bottom: 20px;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  line-height: 140%;
`;

export const Description = styled.div`
  font-size: 14px;
  color: ${globals.MOON_500};
`;

export const DescriptionItalic = styled(Description)`
  font-style: italic;
`;

export const DescriptionDark = styled.div`
  font-size: 14px;
  align-self: start;
  margin-bottom: 16px;
  color: ${globals.gray800};
`;

export const CostPerGB = styled.div`
  color: ${globals.MOON_800};
  font-size: 24px;
  font-weight: 600;
`;

export const Unit = styled.div`
  font-size: 16px;
  color: ${globals.MOON_500};
  padding-left: 4px;
`;

export const Price = styled.div`
  display: flex;
  align-items: baseline;
`;

export const TotalAmountSection = styled.div`
  display: flex;
  background-color: ${globals.WHITE};
  margin-top: 16px;
  margin-bottom: 6px;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid ${globals.MOON_250};
  border-radius: 4px;
`;

export const TotalAmount = styled.div`
  color: ${globals.gray800};
  font-weight: 600;
  font-size: 34px;
  line-height: 43px;
`;

export const DueToday = styled.div`
  color: ${globals.MOON_800};
  font-weight: 600;
  font-size: 14px;
`;

export const PricingTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  flex-direction: column;
`;

export const PricingTable = styled.div`
  width: 100%;
  margin-bottom: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const PricingTableColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  cursor: pointer;
`;

export const PricingTableHeader = styled.div`
  font-family: ${globals.fontName};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 8px;
`;

export const PricingTableBody = styled.div`
  font-family: ${globals.fontName};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 12px;
  flex-direction: row;
`;

export const PricingTableFeatureRow = styled.div`
  font-size: 14px;
  &:not(:first-child) {
    margin-top: 8px;
  }
`;

export const PricingTableDescription = styled.div`
  display: flex;
  font-family: ${globals.fontName};
  font-size: 14px;
  font-style: italic;
  line-height: 1em;
  align-text: left;
  color: ${globals.gray700};
`;

export const ContactSalesSection = styled.p`
  font-size: 13px;
  color: ${globals.gray600};
`;

export const UsageSubscriptionPopup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
`;
export const UsageSubscriptionPopupTitle = styled.div`
  display: flex;
  font-family: ${globals.fontName};
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 24px;
`;

export const UsageSubscriptionPopupContent = styled.div`
  font-family: ${globals.fontName};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 24px;
`;

export const ConfirmationButtons = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  justify-content: space-between !important;

  .action-button {
    border: none;
    background: ${globals.primary} !important;
    color: white;
    width: unset !important;
    &:hover {
      background: #005e80 !important;
      color: white;
    }
  }

  .contact-button {
    width: unset !important;
    background: ${globals.gray100} !important;
    border: 1px solid ${globals.gray400} !important;
  }
}
`;

export const TargetBlankWithStyle = styled(TargetBlank)`
  display: flex;
  flex-direction: row-reverse;
  font-size: 14px;
`;
